import { supabase } from "../supabase/client";

export function isCloudChildId(childId: string | null): childId is string {
  return Boolean(childId && /^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(childId));
}

export async function loadStarBalance(childId: string | null, fallback = 0): Promise<number> {
  if (!supabase || !isCloudChildId(childId)) {
    const saved = Number(localStorage.getItem("lusky:star-total"));
    return Number.isFinite(saved) ? Math.max(0, Math.trunc(saved)) : Math.max(0, Math.trunc(fallback));
  }
  const { data, error } = await supabase.rpc("get_child_star_balance", { p_child_id: childId });
  if (error) return Math.max(0, Math.trunc(fallback));
  const value = Array.isArray(data) ? data[0] : data;
  return Math.max(0, Number(value ?? fallback));
}